import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';

import IconButton from '~/components/IconButton';

const useStyles = makeStyles(({ palette }) => ({
  button: {
    marginBottom: '4px',
    '&.Mui-disabled': {
      opacity: 1,
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
      color: palette.primary.text9,
    },
  },

  isHidden: {
    visibility: 'hidden',
  },
}));

const ChartButton = ({
  onClick,
  className,
  children,
  tooltipProps,
  isActive,
  isHidden,
  disabled,
  ...otherProps
}) => {
  const styles = useStyles();

  return (
    <IconButton
      tooltipProps={tooltipProps}
      className={classNames(styles.button, className, { [styles.isHidden]: isHidden })}
      variant="contained"
      size="small"
      isActive={isActive}
      disabled={disabled}
      onClick={disabled ? null : onClick}
      {...otherProps}
    >
      {children}
    </IconButton>
  );
};

export default ChartButton;
